
<div class="anketa-wrap">
    <back-button></back-button>
    <div class="anketa-block">
    <div class="anketa-block-header">
      <h1 class="anketa-block-header__title din-pro-condensed ">Анкета</h1>
      <h3 class="anketa-block-header__sub-title din-pro-condensed ">Блок №{{anketaData[currentStep].moduleNumber}}</h3>
      @if(anketaData[currentStep].titleModule){
        <p class="anketa-block-header__description din-pro-simple-text ">{{anketaData[currentStep].titleModule}}</p>
      }
    </div>
        <form [formGroup]="anketaForm" class="anketa-block-content"  >
          <ng-container [formGroupName]="'block' + (currentStep + 1)">

            @for (item  of anketaData[currentStep].data; track item.controlName ?? $index) {
              <div class="anketa-block-item">
                <h5 class="anketa-block-item__title din-pro-condensed">
                  {{item?.title}}
                </h5>
                @if(item?.type === 'select'){
                  <p-select
                    [options]="regions()"
                    [formControlName]="item?.controlName ?? null "
                     optionLabel="name"
                     optionValue="value"
                     [filter]="true"
                     [showClear]="true"
                      [placeholder]="item.placeholder"
                      class="custom-select"/>
                }
                @if(item?.type === 'input'){
                  <input class="" [formControlName]="item?.controlName  ?? null " type="text" pInputText />
                }
                @if(item.type === 'radio') {
                  <div class="anketa-block-radio-wrap">
                    @for(option of item?.options; track option.id){
                      <div class="anketa-block-radio-item">
                        <label class="anketa-block-radio-item">
                          <p-radioButton
                            [id]="option?.id"
                            [name]="'radio-' + option.controlName"
                            [formControlName]="option.controlName ?? '' "
                            [value]="option?.value">
                          </p-radioButton>
                          <span  class="course-answer-item" >{{ option.label }}</span>
                        </label>
                      </div>
                    }
                  </div>
                }

                @if(item?.type === 'textarea'){
                  <div class="textarea-wrap">
                    <textarea [autoResize]="true" rows="5" cols="30" pTextarea [formControlName]="item?.controlName ?? '' " ></textarea>
                  </div>
                }

                @if(item?.type === 'radio-select'){
                  <div class="anketa-block-radio-wrap">
                    @for(option of item?.options; track option.id){
                      @if(option.type === 'radio'){
                        <div class="anketa-block-radio-item">
                          <label class="anketa-block-radio-item">
                            <p-radioButton
                              [id]="option?.id"
                              [name]="'radio-' + option.controlName"
                              [formControlName]="option.controlName ?? '' "
                              [value]="option?.value"
                              (onClick)="onRadioChange(option)">
                            </p-radioButton>
                            <span  class="course-answer-item" >{{ option.label }}</span>
                          </label>
                        </div>
                      }
                      @if(option.type === 'textarea'){
                        <div  class="textarea-wrap">
                          <textarea
                            [autoResize]="true" rows="5" cols="30"
                            [id]="option.id"
                            pTextarea [formControlName]="option.controlName ?? ''"
                            [placeholder]="option.placeholder"
                            [class.disabled]="currentBlock.get(`${option.controlName}`)?.disabled"
                          ></textarea>
                          <label class="count-symbol"></label>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            }
          </ng-container>
        </form>
          <button
            (click)="nextStep()"
            class="button active"
            [class.disabled]="currentBlock.invalid"> {{ !isLastStep ? 'Далее' : 'Отправить анкету' }}
          </button>

    </div>
</div>

@if(isModalSuccess()){
  <confirmation-modal
    [typeImage]="'succsessAnketa'"
    [textModal]="'Анкета отправлена'"
    [subTextModal]="'Спасибо! Ваша заявка принята. \n'+
'В ближайшее время мы свяжемся с вами по указанной электронной почте.'"
  >
    <div class="modal-lesson-buttons">
      <button
        (click)="navigateHome()"
        class="button active">Закрыть</button>
    </div>
  </confirmation-modal>
}
